/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import { getItem, setItem } from '../services/local.storage';

type LocalStorageReturn<T> = [value: T, updateValue: (newValue: T) => void];

function useLocalStorage<T>(key: string, initialState: T): LocalStorageReturn<T> {
  const [value, setValue] = useState<T>(initialState);

  const updateValue = (newValue: T) => {
    setItem(key, newValue);
    setValue(newValue);
  };

  useEffect(() => {
    const newValue = getItem<T>(key);

    if (newValue !== null) {
      setValue(newValue);
    }
  }, []);

  return [value, updateValue];
}

export default useLocalStorage;
